import { Injectable, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, PartialObserver, throwError } from 'rxjs';
import { finalize, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ExternalRequestManagerService {
  public requestPending$: BehaviorSubject<boolean>;
  private _requiredApiRequests$: BehaviorSubject<Observable<any>[]>;

  constructor() {
    this.requestPending$ = new BehaviorSubject<boolean>(true);
    this._requiredApiRequests$ = new BehaviorSubject<Observable<any>[]>(null);
    this.checkRequestsOnDone();
  }

  private checkRequestsOnDone() {
    // Check all required api request have finished
    this._requiredApiRequests$.subscribe(x =>{
      var requests = this._requiredApiRequests$.getValue();
      if (requests == null) {
        return;
      }

      if (requests.length == 0) {
        this.requestPending$.next(false);
      }
      else if (requests.length > 0) {
        this.requestPending$.next(true);
      }
    });
  }

  public triggerRequest<T>(request: Observable<T>, observer: PartialObserver<T>): void;
  public triggerRequest<T>(request: Observable<T>): Observable<T>;
  public triggerRequest<T>(request: Observable<T>, observer?: PartialObserver<T>) {
    const requests = this._requiredApiRequests$.getValue() || [];
    requests.push(request);
    this._requiredApiRequests$.next(requests);

    if (observer) {
      request.subscribe({
        next: res => {
          observer.next ? observer.next(res) : null;
        },
        error: err => {
          observer.error ? observer.error(err) : null;
          this.removeCompletedRequest(request);
        },
        complete: () => {
          observer.complete ? observer.complete() : null;
          this.removeCompletedRequest(request);
        }
      });
    } else {
      return request.pipe(
        finalize(() => {
          this.removeCompletedRequest(request);
        }),
        catchError(err => {
          this.removeCompletedRequest(request);
          return throwError(err);
        }),
      );
    }
  }

  private removeCompletedRequest(request: Observable<any>){
    var requests = this._requiredApiRequests$.getValue();
    var index = requests.indexOf(request);
    requests.splice(index,1);
    this._requiredApiRequests$.next(requests);
  }
}
